class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    this.dispatchCartViewEvent();
  }

  // The notification's outer element is server-rendered once at page load, so
  // its `cart` Liquid object reflects the pre-add state. The morphed children
  // (inserted from the /cart/add.js sections response in renderContents) are
  // post-add, but they don't expose the full cart shape we need for the event
  // payload. So we keep an explicit /cart.json fetch on open. Migrating to the
  // factory + filter would require re-rendering the notification element
  // itself in sections, which is out of scope for this PR.
  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      const cart = await response.json();
      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      // cart:view is informational; swallow fetch errors
    }
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);


/* EVASHU CORE — T5 single-owner runtime, 2026-09-21.
   Owns global shell/cart/wishlist/content helpers only.
   Homepage filters, Guidance and Header Search have separate single owners. */
(() => {
  'use strict';
  const cfgNode=document.getElementById('EvashuRuntimeConfig');
  let parsed={};
  try{parsed=cfgNode?JSON.parse(cfgNode.textContent||'{}'):{};}catch(e){console.error('[Evashu] Invalid runtime config.',e);}
  window.EvashuRuntime=Object.freeze({...window.EvashuRuntime,...parsed});

  const cfg=()=>window.EvashuRuntime||{};
  const str=(k,f)=>cfg().strings?.[k]||f;
  const routeRoot=()=>window.Shopify?.routes?.root||cfg().routes?.root||'/';
  const wishKey='evashu_wishlist_v1';
  const headers=new WeakMap();
  const homePage=!!document.querySelector('[data-eih-home]');
  let cartRequest,wishDialog;

  const announce=(msg,scope=document)=>{const n=scope.querySelector?.('.eih-runtime-status')||document.querySelector('.eih-runtime-status');if(!n)return;n.textContent='';requestAnimationFrame(()=>n.textContent=msg);};
  const norm=(v)=>{try{const u=new URL(v,location.origin);return `${u.pathname}${u.search}`;}catch(_){return String(v||'');}};
  const readWish=()=>{try{const x=JSON.parse(localStorage.getItem(wishKey)||'[]');return Array.isArray(x)?x.filter(i=>i?.url&&i?.title):[];}catch(_){return[];}};
  const saveWish=(x)=>{try{localStorage.setItem(wishKey,JSON.stringify(x));}catch(_){}};
  const product=(b)=>{const a=b.closest('.eih-product-card')?.querySelector('h3 a[href]');return a?{url:norm(a.href),title:a.textContent.trim()||'Product'}:null;};

  const syncWish=(scope=document)=>{
    const list=readWish(),saved=new Set(list.map(i=>norm(i.url)));
    scope.querySelectorAll?.('.eih-wish[data-eih-wish]').forEach(b=>{const p=product(b);if(!p)return;const on=saved.has(p.url);b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',String(on));b.textContent=on?'♥':'♡';b.setAttribute('aria-label',`${on?str('wishlistRemoveFrom','Remove from wishlist'):str('wishlistAddTo','Add to wishlist')}: ${p.title}`);});
    document.querySelectorAll('.eih-round[data-eih-wish]').forEach(b=>{b.textContent=list.length?'♥':'♡';b.setAttribute('aria-pressed',String(list.length>0));b.setAttribute('aria-label',`${str('wishlist','Wishlist')} · ${list.length} saved`);});
  };
  const ensureWishDialog=()=>{
    if(wishDialog?.isConnected)return wishDialog;if(typeof HTMLDialogElement==='undefined')return null;
    wishDialog=document.createElement('dialog');wishDialog.className='eih-wishlist-dialog';wishDialog.setAttribute('aria-labelledby','EihWishlistTitle');
    wishDialog.innerHTML='<div class="eih-wishlist-dialog__panel"><div class="eih-wishlist-dialog__header"><h2 id="EihWishlistTitle"></h2><button type="button" class="eih-wishlist-dialog__close">×</button></div><div class="eih-wishlist-dialog__content" data-eih-wishlist-content></div></div>';
    wishDialog.querySelector('h2').textContent=str('wishlist','Wishlist');const close=wishDialog.querySelector('.eih-wishlist-dialog__close');close.setAttribute('aria-label',str('close','Close'));close.addEventListener('click',()=>wishDialog.close());wishDialog.addEventListener('click',e=>{if(e.target===wishDialog)wishDialog.close();});wishDialog.addEventListener('close',()=>document.documentElement.classList.remove('eih-dialog-open'));document.body.appendChild(wishDialog);return wishDialog;
  };
  const renderWish=()=>{
    const d=ensureWishDialog();if(!d)return;const c=d.querySelector('[data-eih-wishlist-content]'),list=readWish();c.replaceChildren();
    if(!list.length){const p=document.createElement('p');p.className='eih-wishlist-dialog__empty';p.textContent=str('wishlistEmpty','Your wishlist is empty.');c.appendChild(p);}else{const ul=document.createElement('ul');ul.className='eih-wishlist-dialog__list';list.forEach(i=>{const li=document.createElement('li'),a=document.createElement('a'),b=document.createElement('button');a.href=i.url;a.textContent=i.title;b.type='button';b.textContent=str('wishlistRemove','Remove');b.addEventListener('click',()=>{saveWish(readWish().filter(x=>norm(x.url)!==norm(i.url)));syncWish();renderWish();announce(str('wishlistRemoved','Removed from wishlist.'));});li.append(a,b);ul.appendChild(li);});c.appendChild(ul);}
    document.documentElement.classList.add('eih-dialog-open');if(!d.open)d.showModal();d.querySelector('.eih-wishlist-dialog__close')?.focus();
  };
  const toggleWish=(b)=>{const p=product(b);if(!p)return;const l=readWish(),has=l.some(i=>norm(i.url)===p.url);saveWish(has?l.filter(i=>norm(i.url)!==p.url):[...l,p].slice(-50));syncWish();announce(has?str('wishlistRemoved','Removed from wishlist.'):str('wishlistSaved','Saved to wishlist.'));};

  const inert=(on)=>document.querySelectorAll('#MainContent,.shopify-section-group-footer-group').forEach(n=>n.toggleAttribute('inert',on));
  const initHeader=(shell)=>{
    if(!shell||headers.has(shell))return;const ac=new AbortController();headers.set(shell,ac);const {signal}=ac,b=shell.querySelector('[data-eih-mobile-menu]'),d=shell.querySelector('[data-eih-mobile-drawer]'),t=shell.querySelector('[data-eih-mobile-drawer-template]'),geo=shell.querySelector('[data-eih-geo]'),geoClose=shell.querySelector('[data-eih-geo-close]'),mq=matchMedia('(max-width:760px)');let prior;
    const mountDrawer=()=>{if(!d)return null;if(d.dataset.eihDrawerHydrated==='true')return d;if(t instanceof HTMLTemplateElement){d.appendChild(t.content.cloneNode(true));d.dataset.eihDrawerHydrated='true';t.remove();}return d;};
    const focusables=()=>[...(mountDrawer()?.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')||[])];
    const close=(restore=true)=>{if(!d||!b)return;d.classList.remove('is-open');d.setAttribute('aria-hidden','true');b.setAttribute('aria-expanded','false');b.setAttribute('aria-label',str('openMenu','Open menu'));b.textContent='☰';document.documentElement.classList.remove('eih-menu-open');document.body.classList.remove('eih-menu-open');inert(false);if(restore&&prior instanceof HTMLElement)prior.focus();};
    const open=()=>{const drawer=mountDrawer();if(!drawer||!b)return;prior=document.activeElement;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');b.setAttribute('aria-expanded','true');b.setAttribute('aria-label',str('closeMenu','Close menu'));b.textContent='×';document.documentElement.classList.add('eih-menu-open');document.body.classList.add('eih-menu-open');inert(true);requestAnimationFrame(()=>focusables()[0]?.focus());};
    d?.setAttribute('aria-hidden',d.classList.contains('is-open')?'false':'true');b?.addEventListener('click',()=>d?.classList.contains('is-open')?close():open(),{signal});d?.addEventListener('click',e=>{if(e.target.closest('a[href]'))close(false);},{signal});
    document.addEventListener('keydown',e=>{if(!d?.classList.contains('is-open'))return;if(e.key==='Escape'){e.preventDefault();close();return;}if(e.key!=='Tab')return;const f=focusables();if(!f.length)return;if(e.shiftKey&&document.activeElement===f[0]){e.preventDefault();f.at(-1).focus();}else if(!e.shiftKey&&document.activeElement===f.at(-1)){e.preventDefault();f[0].focus();}},{signal});
    document.addEventListener('pointerdown',e=>{if(d?.classList.contains('is-open')&&!shell.contains(e.target))close();},{signal});mq.addEventListener?.('change',()=>{if(!mq.matches)close(false);},{signal});
    try{if(geo&&sessionStorage.getItem('eih_geo_dismissed')==='1')geo.hidden=true;}catch(_){}geoClose?.addEventListener('click',()=>{geo.hidden=true;try{sessionStorage.setItem('eih_geo_dismissed','1');}catch(_){}},{signal});
  };

  const mountCart=()=>{if(document.querySelector('[data-eih-cart-runtime]'))return;const t=document.getElementById('EvashuCartRuntimeTemplate');if(t instanceof HTMLTemplateElement)document.body.appendChild(t.content.cloneNode(true));};
  const positionCart=()=>{const r=document.querySelector('[data-eih-cart-runtime]'),h=document.querySelector('.eih-header');if(r&&h)r.style.setProperty('--eih-cart-notification-top',`${Math.max(8,Math.round(h.getBoundingClientRect().bottom+8))}px`);};
  let cartPositionFrame=0;
  const scheduleCartPosition=()=>{if(cartPositionFrame)return;cartPositionFrame=requestAnimationFrame(()=>{cartPositionFrame=0;positionCart();});};
  const syncCart=(n)=>{const x=Math.max(0,parseInt(n,10)||0);document.querySelectorAll('.eih-round--cart').forEach(a=>{a.textContent=String(x);a.setAttribute('aria-label',`${str('cart','Cart')}: ${x}`);});};
  const refreshCart=()=>{if(cartRequest)return cartRequest;cartRequest=fetch(`${routeRoot().replace(/\/$/,'')}/cart.js`,{credentials:'same-origin',headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():Promise.reject()).then(c=>{syncCart(c.item_count??c.total_quantity??0);return c;}).catch(()=>null).finally(()=>cartRequest=null);return cartRequest;};
  const seedCartFromServer=()=>{const a=document.querySelector('.eih-round--cart');const n=Number.parseInt(a?.textContent?.trim()||'',10);if(!Number.isFinite(n))return false;syncCart(n);return true;};

  const footer=(scope=document)=>{const gs=scope.querySelectorAll?.('.ev-footer__group')||[];if(!gs.length)return;const mq=matchMedia('(max-width:749px)'),sync=()=>gs.forEach(g=>mq.matches?g.removeAttribute('open'):g.setAttribute('open',''));sync();if(!document.documentElement.dataset.evFooterMediaBound){document.documentElement.dataset.evFooterMediaBound='true';const all=()=>footer(document);mq.addEventListener?mq.addEventListener('change',all):mq.addListener(all);}};
  const descriptions=(scope=document)=>scope.querySelectorAll?.('.product__description').forEach(x=>{if(x.dataset.evDescriptionReady==='true')return;x.dataset.evDescriptionReady='true';if(x.scrollHeight<=260)return;x.classList.add('ev-is-collapsible');const b=document.createElement('button');b.type='button';b.className='ev-description-toggle';b.textContent=str('readFullDetails','Read full details');b.setAttribute('aria-expanded','false');x.after(b);b.addEventListener('click',()=>{const on=x.classList.toggle('ev-is-open');b.textContent=on?str('showLess','Show less'):str('readFullDetails','Read full details');b.setAttribute('aria-expanded',String(on));});});
  const collectionIntros=(scope=document)=>scope.querySelectorAll?.('.ev-collection-intro__copy').forEach(x=>{if(x.dataset.evCollectionIntroReady==='true')return;x.dataset.evCollectionIntroReady='true';if(x.scrollHeight<=150)return;x.classList.add('ev-is-collapsible');const b=x.parentElement?.querySelector('.ev-collection-intro__toggle');if(!b)return;b.hidden=false;b.addEventListener('click',()=>{const on=x.classList.toggle('ev-is-open');b.textContent=on?str('showLess','Show less'):str('readMore','Read more');b.setAttribute('aria-expanded',String(on));});});
  const scopeInit=(scope=document)=>{scope.querySelectorAll?.('[data-eih-header]').forEach(initHeader);syncWish(scope);if(!homePage){footer(scope);descriptions(scope);collectionIntros(scope);}};
  const init=()=>{mountCart();positionCart();scopeInit();if(!seedCartFromServer())refreshCart();
    document.addEventListener('click',e=>{const p=e.target.closest('.eih-wish[data-eih-wish]');if(p){e.preventDefault();toggleWish(p);return;}if(e.target.closest('.eih-round[data-eih-wish]')){e.preventDefault();renderWish();}});
    document.addEventListener('shopify:section:load',e=>{scopeInit(e.target);mountCart();positionCart();});document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll?.('[data-eih-header]').forEach(h=>{headers.get(h)?.abort();headers.delete(h);}));document.addEventListener('product-info:loaded',e=>{descriptions(e.target);collectionIntros(e.target);});document.addEventListener('shopify:cart:lines-update',()=>setTimeout(refreshCart,50));window.addEventListener('storage',e=>{if(e.key===wishKey)syncWish();});window.addEventListener('pageshow',e=>{if(e.persisted)refreshCart();});window.addEventListener('resize',homePage?scheduleCartPosition:positionCart,{passive:true});window.addEventListener('scroll',homePage?scheduleCartPosition:positionCart,{passive:true});if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,()=>setTimeout(refreshCart,80));
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();


/*
 * EVASHU HEADER SEARCH V3 — BODY-LEVEL MODAL OWNER — 2026-09-24
 * Filename retained for pipeline compatibility. The retired V2 implementation
 * mounted search inside the header/drawer and caused mobile overlap/reflow.
 * This version owns one body-level modal, product-only predictive results and
 * never relocates or hides the header trigger.
 */
(() => {
  'use strict';

  if (window.__eihHeaderSearchV3Bound) return;
  window.__eihHeaderSearchV3Bound = true;
  window.__eihHeaderSearchV2Bound = true;

  const TRIGGER_SELECTOR = '.eih-search, .eih-drawer__search';
  const searchIcon = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true" focusable="false"><circle cx="10.8" cy="10.8" r="6.4" stroke="currentColor" stroke-width="1.8"/><path d="m15.5 15.5 4.2 4.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  const closeIcon = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  let ui = null;
  let activeTrigger = null;
  let restoreTarget = null;
  let timer = null;
  let controller = null;
  let requestToken = 0;

  const searchUrl = (query) =>
    `/search/suggest?q=${encodeURIComponent(query.trim())}&section_id=predictive-search&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`;

  const setPageInert = (on) => {
    document.querySelectorAll('#MainContent,.shopify-section-group-header-group,.shopify-section-group-footer-group').forEach((node) => {
      if (node === ui?.root || node.contains(ui?.root)) return;
      node.toggleAttribute('inert', on);
    });
  };

  const resetResults = () => {
    if (!ui) return;
    ui.results.hidden = true;
    ui.results.replaceChildren();
    ui.input.setAttribute('aria-expanded', 'false');
    ui.results.removeAttribute('aria-busy');
  };

  const announce = (message) => {
    if (!ui) return;
    ui.live.textContent = '';
    requestAnimationFrame(() => { ui.live.textContent = message; });
  };

  const makeEmpty = (query) => {
    const empty = document.createElement('div');
    empty.className = 'eih-header-search__empty';
    const title = document.createElement('strong');
    title.textContent = 'No product matches yet.';
    const copy = document.createElement('span');
    copy.textContent = `Try a shorter crystal, product or intention for “${query}”.`;
    empty.append(title, copy);
    ui.results.replaceChildren(empty);
    ui.results.hidden = false;
    ui.input.setAttribute('aria-expanded', 'true');
    announce('No product suggestions found.');
  };

  const renderProducts = (query, documentResult) => {
    const source = documentResult.querySelector('#predictive-search-results-products-list');
    const sourceItems = source ? Array.from(source.children).slice(0, 6) : [];

    if (!sourceItems.length) {
      makeEmpty(query);
      return;
    }

    const wrap = document.createElement('div');
    wrap.className = 'eih-header-search__suggestions';

    const heading = document.createElement('p');
    heading.className = 'eih-header-search__results-label';
    heading.textContent = 'Products';

    const list = document.createElement('ul');
    list.className = 'eih-header-search__product-list';
    list.setAttribute('role', 'list');

    sourceItems.forEach((sourceItem) => {
      const sourceLink = sourceItem.querySelector('a.predictive-search__item');
      if (!sourceLink) return;

      const item = document.createElement('li');
      item.className = 'eih-header-search__product-item';
      const link = sourceLink.cloneNode(true);
      link.removeAttribute('id');
      link.tabIndex = 0;
      link.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      item.appendChild(link);
      list.appendChild(item);
    });

    if (!list.children.length) {
      makeEmpty(query);
      return;
    }

    const all = document.createElement('a');
    all.className = 'eih-header-search__all';
    all.href = `/search?q=${encodeURIComponent(query)}&type=product`;
    all.textContent = `See all results for “${query}” →`;

    wrap.append(heading, list, all);
    ui.results.replaceChildren(wrap);
    ui.results.hidden = false;
    ui.input.setAttribute('aria-expanded', 'true');
    announce(`${list.children.length} product suggestions available.`);
  };

  const runSearch = async (query) => {
    const token = ++requestToken;
    controller?.abort();
    controller = new AbortController();
    resetResults();
    ui.results.setAttribute('aria-busy', 'true');
    announce('Searching products.');

    try {
      const response = await fetch(searchUrl(query), {
        signal: controller.signal,
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(String(response.status));

      const result = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (token !== requestToken) return;
      renderProducts(query, result);
    } catch (error) {
      if (error?.name === 'AbortError' || token !== requestToken) return;
      const errorNode = document.createElement('div');
      errorNode.className = 'eih-header-search__empty';
      const title = document.createElement('strong');
      title.textContent = 'Quick results are unavailable.';
      const copy = document.createElement('span');
      copy.textContent = 'Press Enter to search the store.';
      errorNode.append(title, copy);
      ui.results.replaceChildren(errorNode);
      ui.results.hidden = false;
      ui.input.setAttribute('aria-expanded', 'true');
      announce('Quick results are unavailable. Press Enter to search.');
    } finally {
      if (token === requestToken) {
        ui.results.removeAttribute('aria-busy');
        controller = null;
      }
    }
  };

  const clearSearch = () => {
    clearTimeout(timer);
    controller?.abort();
    controller = null;
    requestToken += 1;
    ui.input.value = '';
    ui.clear.hidden = true;
    ui.hint.hidden = false;
    resetResults();
    announce('Search cleared.');
    ui.input.focus({ preventScroll: true });
  };

  const close = (restoreFocus = true) => {
    if (!ui || ui.root.hidden) return;

    clearTimeout(timer);
    controller?.abort();
    controller = null;
    requestToken += 1;
    ui.root.hidden = true;
    ui.input.value = '';
    ui.clear.hidden = true;
    ui.hint.hidden = false;
    resetResults();
    ui.live.textContent = '';

    document.documentElement.classList.remove('eih-search-modal-open');
    document.body.classList.remove('eih-search-modal-open');
    setPageInert(false);

    if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
    const target = restoreTarget;
    activeTrigger = null;
    restoreTarget = null;
    if (restoreFocus && target instanceof HTMLElement) target.focus({ preventScroll: true });
  };

  const make = () => {
    const root = document.createElement('div');
    root.className = 'eih-header-search eih-header-search--modal';
    root.hidden = true;
    root.innerHTML = `
      <div class="eih-header-search__backdrop" data-eih-search-backdrop aria-hidden="true"></div>
      <section class="eih-header-search__panel" role="dialog" aria-modal="true" aria-label="Search Evashu">
        <div class="eih-header-search__top">
          <strong>Search Evashu</strong>
          <button class="eih-header-search__close" type="button" aria-label="Close search">${closeIcon}</button>
        </div>
        <form class="eih-header-search__form" action="/search" method="get" role="search">
          <input type="hidden" name="type" value="product">
          <div class="eih-header-search__field">
            <span class="eih-header-search__icon" aria-hidden="true">${searchIcon}</span>
            <label class="eih-sr-only" for="EihHeaderSearchInput">Search products</label>
            <input id="EihHeaderSearchInput" class="eih-header-search__input" type="search" name="q"
              placeholder="Search crystals or products" autocomplete="off" autocapitalize="off" spellcheck="false"
              role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="EihHeaderSearchResults">
            <button class="eih-header-search__clear" type="button" aria-label="Clear search" hidden>${closeIcon}</button>
          </div>
          <p class="eih-header-search__hint">Try “amethyst”, “protection” or “bracelet”.</p>
          <div id="EihHeaderSearchResults" class="eih-header-search__results" role="region" aria-label="Product search suggestions" hidden></div>
          <span class="eih-sr-only" data-eih-search-live aria-live="polite"></span>
        </form>
      </section>`;

    document.body.appendChild(root);

    const instance = {
      root,
      panel: root.querySelector('.eih-header-search__panel'),
      form: root.querySelector('.eih-header-search__form'),
      input: root.querySelector('.eih-header-search__input'),
      clear: root.querySelector('.eih-header-search__clear'),
      close: root.querySelector('.eih-header-search__close'),
      hint: root.querySelector('.eih-header-search__hint'),
      results: root.querySelector('.eih-header-search__results'),
      live: root.querySelector('[data-eih-search-live]'),
      backdrop: root.querySelector('[data-eih-search-backdrop]')
    };

    instance.clear.addEventListener('click', clearSearch);
    instance.close.addEventListener('click', () => close(true));
    instance.backdrop.addEventListener('click', () => close(true));

    instance.input.addEventListener('input', () => {
      const query = instance.input.value.trim();
      instance.clear.hidden = query.length === 0;
      instance.hint.hidden = query.length > 0;
      clearTimeout(timer);

      if (query.length < 2) {
        controller?.abort();
        controller = null;
        requestToken += 1;
        resetResults();
        return;
      }

      timer = setTimeout(() => runSearch(query), 150);
    });

    instance.form.addEventListener('submit', (event) => {
      if (!instance.input.value.trim()) {
        event.preventDefault();
        instance.input.focus({ preventScroll: true });
      }
    });

    return instance;
  };

  const open = (trigger) => {
    if (!ui) ui = make();
    if (!ui.root.hidden) return;

    activeTrigger = trigger;
    const shell = trigger.closest('.eih-shell');
    restoreTarget = trigger.classList.contains('eih-drawer__search')
      ? shell?.querySelector('[data-eih-mobile-menu]') || trigger
      : trigger;

    trigger.setAttribute('aria-expanded', 'true');
    ui.root.hidden = false;
    document.documentElement.classList.add('eih-search-modal-open');
    document.body.classList.add('eih-search-modal-open');
    setPageInert(true);
    requestAnimationFrame(() => ui.input.focus({ preventScroll: true }));
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (!ui || ui.root.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close(true);
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = Array.from(ui.panel.querySelectorAll('button:not([disabled]):not([hidden]),input:not([disabled]),a[href]'))
      .filter((node) => node.offsetParent !== null);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();


/* EVASHU STORE-WIDE CLICK + QA RUNTIME — 2026-09-02 */
/* PERFORMANCE CLEANUP — 2026-09-29: removed the unreachable homepage catalog fetch/repaint block. */
(()=>{
  if(window.__evashuStoreQaBound)return;
  window.__evashuStoreQaBound=true;

  const CARD_SELECTOR='.eih-edu,.ev-education__card,.product-card-wrapper,.article-card-wrapper,.eih-product-card,.eih-mini-product,.collection-list__item';
  const INTERACTIVE='a,button,input,select,textarea,label,summary,details,[role="button"],[contenteditable="true"]';

  const canonicalLink=card=>{
    if(card.matches('.eih-edu'))return card.querySelector('.eih-edu__body a[href],a[href]');
    if(card.matches('.ev-education__card'))return card.querySelector('a[href]');
    if(card.matches('.product-card-wrapper,.article-card-wrapper,.collection-list__item'))return card.querySelector('.card__heading a[href],a.full-unstyled-link[href],a[href]');
    if(card.matches('.eih-product-card'))return card.querySelector('h3 a[href],.eih-product-card__title a[href],a[href]');
    if(card.matches('.eih-mini-product'))return card.querySelector('.eih-mini-product__link[href],a[href]');
    return null;
  };

  document.addEventListener('click',event=>{
    if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    if(event.target.closest(INTERACTIVE))return;
    const card=event.target.closest(CARD_SELECTOR);if(!card)return;
    const link=canonicalLink(card);if(link?.href)window.location.assign(link.href);
  });

  const normalizeAllCrystals=root=>{
    (root||document).querySelectorAll?.('a[href]')?.forEach(a=>{
      try{
        const u=new URL(a.href,location.origin);
        if(u.origin===location.origin&&u.pathname==='/collections/all')a.href='/collections/all-crystals'+u.search+u.hash;
      }catch(_e){}
    });
  };

  const repairTrustCopy=root=>{
    (root||document).querySelectorAll?.('[data-ivx-root]')?.forEach(x=>{
      x.setAttribute('aria-label','Why trust Evashu');
      const h=x.querySelector('.ivx-head h2');if(h)h.textContent='Evashu';
      const sub=x.querySelector('.ivx-head h2+div');if(sub)sub.textContent='Material clarity. Secure checkout. Tracked international delivery.';
      const pillars=x.querySelector('.ivx-pillars');if(pillars)pillars.setAttribute('aria-label','Evashu trust pillars');
      const tabs=x.querySelector('.ivx-tabs');if(tabs)tabs.setAttribute('aria-label','Explore Evashu trust details');
      const auth=x.querySelector('.ivx-pillar[data-ivx-key="authenticity"]');if(auth){const s=auth.querySelector('strong'),m=auth.querySelector('small');if(s)s.textContent='Materials';if(m)m.textContent='Clear product descriptions'}
      const source=x.querySelector('.ivx-pillar[data-ivx-key="impact"]');if(source){const s=source.querySelector('strong'),m=source.querySelector('small');if(s)s.textContent='Sourcing';if(m)m.textContent='Supplier relationships'}
      const at=x.querySelector('.ivx-tab[data-ivx-key="authenticity"] span');if(at)at.textContent='Materials';
      const st=x.querySelector('.ivx-tab[data-ivx-key="impact"] span');if(st)st.textContent='Sourcing';
      const badges=[...x.querySelectorAll('.ivx-badges span')];['Material clarity','Secure','Sourcing clarity','Worldwide'].forEach((t,i)=>{if(badges[i]){const svg=badges[i].querySelector('svg');badges[i].textContent=t;if(svg)badges[i].prepend(svg)}});
    });
  };

  const repairPdp=root=>{
    const scope=root||document;
    const productTitle=scope.querySelector?.('.product__title h1')?.textContent?.trim()||document.querySelector('.product__title h1')?.textContent?.trim();
    scope.querySelectorAll?.('.product__text.caption-with-letter-spacing')?.forEach(n=>{if(n.textContent.trim()==='Authentic crystal · Selected in India')n.textContent='Material details · Selected in India'});
    scope.querySelectorAll?.('.icon-with-text__item .h4')?.forEach(n=>{if(n.textContent.trim()==='Natural & authentic')n.textContent='Material disclosed'});
    scope.querySelectorAll?.('.product__accordion details')?.forEach(d=>{
      const title=d.querySelector('.accordion__title')?.textContent.trim();const body=d.querySelector('.accordion__content');
      if(title==='Authenticity & Sourcing'){
        const t=d.querySelector('.accordion__title');if(t)t.textContent='Materials & Sourcing';
        if(body)body.innerHTML='<p>We work with sourcing partners in India and describe material type, size, finish, and any relevant treatment or natural variation on each product listing.</p>';
      }else if(title==='Care & Cleansing'&&body){
        body.innerHTML='<p>Use material-specific care before applying water, sunlight, salt or cleaning products. A soft dry cloth is the safest starting point when the material or treatment is uncertain.</p>';
      }else if(title==='Shipping, Returns & Support'&&body){
        body.innerHTML=body.innerHTML.replace('8–15 business days','8–15 days');
      }
    });
    if(productTitle)scope.querySelectorAll?.('.product__media img,.thumbnail img,.product-media-modal img')?.forEach(img=>{if(!img.getAttribute('alt')?.trim())img.alt=productTitle});
  };

  const repairGiftLabel=root=>{
    (root||document).querySelectorAll?.('.eih-gift__paths a')?.forEach(a=>{if(a.textContent.trim().startsWith('Gifts under $25'))a.innerHTML='Crystal gifts <span>→</span>'});
  };

  const qaHomePage=!!document.querySelector('[data-eih-home]');
  const run=root=>{normalizeAllCrystals(root);if(qaHomePage){repairGiftLabel(root);return;}repairTrustCopy(root);repairPdp(root);repairGiftLabel(root)};
  run(document);
  document.addEventListener('shopify:section:load',e=>{run(e.target)});
})();
